export default function() {
    if (new URL(window.location.href).hostname == 'd10.gokhalemethod.com') {
        return 'https://gokhale-test.webintuitive.co.uk/';
    }

    return process.env.MIX_APP_URL;
}

